import { render, staticRenderFns } from "./GeneralSettingsEMS.vue?vue&type=template&id=0c3f7679&scoped=true&"
import script from "./GeneralSettingsEMS.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsEMS.vue?vue&type=script&lang=ts&"
import style0 from "./GeneralSettingsEMS.vue?vue&type=style&index=0&id=0c3f7679&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f7679",
  null
  
)

export default component.exports